
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/local/[state]/[city]/[area]",
      function () {
        return require("private-next-pages/local/[state]/[city]/[area].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/local/[state]/[city]/[area]"])
      });
    }
  